import type { ReactElement } from 'react';
import { skeletonLine } from '@/components/ui/skeleton';

/** Skeleton contextual con la forma del expediente (cabecera + dos columnas), no un
 *  spinner genérico (UX-LOAD-01). */
export function DossierSkeleton(): ReactElement {
  return (
    <div aria-busy="true" aria-label="Cargando expediente">
      <div className="card" style={{ marginBottom: 16 }}>
        <div className="cb" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div className={skeletonLine({ width: 'lg' })} />
          <div className={skeletonLine({ width: 60, height: 'md' })} />
          <div className={skeletonLine({ width: 90 })} />
        </div>
      </div>
      <div className="g-84">
        <div className="stack">
          {[0, 1].map((i) => (
            <div className="card" key={i}>
              <div className="cb" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                <div className={skeletonLine({ width: 40 })} />
                <div className={skeletonLine({ width: 80 })} />
                <div className={skeletonLine({ width: 70 })} />
              </div>
            </div>
          ))}
        </div>
        <div className="stack">
          <div className="card">
            <div className="cb" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <div className={skeletonLine({ width: 50 })} />
              <div className={skeletonLine({ width: 80 })} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
